var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getChainById, MetaMaskProviderErrorCode, prefixChainId, } from '@lifi/sdk';
import { supportedWallets } from '@lifi/wallet-management';
const getAppropriateProvider = () => {
    const walletConnect = supportedWallets.find((wallet) => wallet.name === 'Wallet Connect');
    const tallyho = supportedWallets.find((wallet) => wallet.name === 'Tally Ho');
    let provider;
    if ((walletConnect === null || walletConnect === void 0 ? void 0 : walletConnect.web3react.connector).isCurrentlyUsed) {
        provider = (walletConnect === null || walletConnect === void 0 ? void 0 : walletConnect.web3react.connector)
            .walletConnectProvider;
    }
    else if ((tallyho === null || tallyho === void 0 ? void 0 : tallyho.web3react.connector).isCurrentlyUsed) {
        const { tally } = window;
        provider = tally;
    }
    else {
        const { ethereum } = window;
        provider = ethereum;
    }
    return provider;
};
export const switchChain = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        var _a;
        const provider = getAppropriateProvider();
        if (!provider) {
            resolve(false);
        }
        try {
            provider
                .request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: (_a = getChainById(chainId).metamask) === null || _a === void 0 ? void 0 : _a.chainId }],
            })
                .catch((error) => {
                if (error.code !== MetaMaskProviderErrorCode.userRejectedRequest) {
                    addChain(chainId).then((result) => resolve(result));
                }
                else {
                    reject(error);
                }
            });
            provider.once('chainChanged', (id) => {
                if (parseInt(id) === chainId) {
                    resolve(true);
                }
            });
        }
        catch (error) {
            // const ERROR_CODE_UNKNOWN_CHAIN = 4902
            if (error.code !== MetaMaskProviderErrorCode.userRejectedRequest) {
                addChain(chainId).then((result) => resolve(result));
            }
            else {
                console.error(error);
                resolve(false);
            }
        }
    });
});
export const addChain = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    const provider = getAppropriateProvider();
    if (!provider) {
        return false;
    }
    const params = getChainById(chainId).metamask;
    try {
        yield provider.request({
            method: 'wallet_addEthereumChain',
            params: [params],
        });
        return true;
    }
    catch (error) {
        console.error(`Error adding chain ${chainId}: ${error.message}`);
    }
    return false;
});
export const addToken = (token) => __awaiter(void 0, void 0, void 0, function* () {
    const provider = getAppropriateProvider();
    if (!provider) {
        return false;
    }
    try {
        // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        const wasAdded = yield provider.request({
            method: 'wallet_watchAsset',
            params: {
                type: 'ERC20',
                options: {
                    address: token.address,
                    symbol: token.symbol,
                    decimals: token.decimals,
                    image: token.logoURI, // A string url of the token logo
                },
            },
        });
        return wasAdded;
    }
    catch (error) {
        console.error(error);
    }
    return false;
});
export const switchChainAndAddToken = (chainId, token) => __awaiter(void 0, void 0, void 0, function* () {
    const provider = getAppropriateProvider();
    if (!provider) {
        return;
    }
    const chainIdPrefixed = prefixChainId(chainId);
    if (chainIdPrefixed !== provider.chainId) {
        yield switchChain(chainId);
        provider.once('chainChanged', (id) => __awaiter(void 0, void 0, void 0, function* () {
            if (parseInt(id, 10) === chainId) {
                yield addToken(token);
            }
        }));
    }
    else {
        yield addToken(token);
    }
});
